import * as React from 'react';

import { getProductView_productDetailByMasterId_variants } from '@containers/ProductDetailContainer/queries/__generated__/getProductView';

import { DermoIcon } from './styled';

interface IProductPictogramProps {
  attributes: getProductView_productDetailByMasterId_variants['attributes'];
}

export const ProductPictogram: React.FC<IProductPictogramProps> = ({
  attributes,
}) => {
  if (attributes?.Dermo) {
    return <DermoIcon data-testid="dermo-pictogram" />;
  }

  return null;
};
